module.exports = __webpack_public_path__ + "img/dial-m-m.1aa9fa48.svg";